import { call, put, takeLatest } from "redux-saga/effects";
import { tongHopToanKhoaApi } from "../../../api/tong-hop-diem/tongHopToanKhoaApi";
import { ITongHopToanKhoaRequest } from "../../../model/request/tong-hop-diem/ITongHopToanKhoaRequest";
import { IBaseResponse } from "../../../model/response/IBaseResponse";
import { eTongHopToanKhoaActionIds, ITongHopToanKhoaActionTypes } from "../../action-types/tong-hop-diem/ITongHopToanKhoaActions";
import { rootActions } from "../../actions/rootActions";
import { toLowerCaseDeep } from "../../../utils/toLowerCaseDeep";

export function* tongHopToanKhoaSaga(): any {
    yield takeLatest(eTongHopToanKhoaActionIds.LOAD_START, loadWorker);
}

function* loadWorker(action: ITongHopToanKhoaActionTypes)
{
    const request = action.payload as ITongHopToanKhoaRequest;
    const response: IBaseResponse = yield call(tongHopToanKhoaApi.Select, request);
    if (response.is_success) {
        yield put(rootActions.tongHopDiem.tongHopToanKhoa.LOAD_SUCCESS(toLowerCaseDeep(response.data)));
    } else {
        yield put(rootActions.tongHopDiem.tongHopToanKhoa.LOAD_ERROR(response.message ?? "Có lỗi"));
    }
}